import { useOrderDownloadStore } from '@/stores/order-download';
import { useUserStore } from '@/stores/user';
import { LineSelectableFields } from '@onrunning/backstage-models';
import {
  defaultSelectedLineFields,
  disabledFieldsForDistributor,
} from '@onrunning/backstage-models/dist/orders/line-selectable-fields.model';
import { computed } from 'vue';

export function useSelectableFields() {
  const orderDownloadStore = useOrderDownloadStore();
  const { accountIsDistributor } = useUserStore();

  const selectableFields = computed(() => {
    const existingSelectedFields = orderDownloadStore.selectableFields;

    if (Object.keys(existingSelectedFields).length > 0) {
      return filterFields(existingSelectedFields);
    }

    const selectableFieldInstance = new LineSelectableFields();

    for (const fieldKey in selectableFieldInstance) {
      const key = fieldKey as keyof LineSelectableFields;
      selectableFieldInstance[key] = {
        isSelected: defaultSelectedLineFields.has(key),
        key: key,
      };
    }

    const filteredFields = filterFields(selectableFieldInstance);
    orderDownloadStore.setSelectableFields(filteredFields);

    return orderDownloadStore.selectableFields;
  });

  const filterFields = (fields: LineSelectableFields): LineSelectableFields => {
    if (!accountIsDistributor()) {
      return fields;
    }

    const filteredFields = {} as LineSelectableFields;

    for (const fieldKey in fields) {
      const key = fieldKey as keyof LineSelectableFields;
      const fieldValue = fields[key];

      if (disabledFieldsForDistributor.has(key)) {
        delete filteredFields[key];
        orderDownloadStore.selectableFields[key] = { isSelected: false, key: key };
      } else {
        filteredFields[key] = fieldValue;
      }
    }

    return filteredFields;
  };

  return {
    selectableFields,
  };
}
